import Api, { handleError } from '@/services/Api';

const API_URL = process.env.API_BASE;

export async function getStripeConfigApi() {
  const url = `${API_URL}/stripe/config/`;
  const response = await Api.get(url).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}

export async function createCardSetupIntentApi(payload) {
  const url = `${API_URL}/payment/card-setup-intent/`;
  const response = await Api.post(url, payload).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}

export async function createGuestCardSetupIntentApi(payload) {
  const url = `${API_URL}/payment/guest-card-setup-intent/`;
  const response = await Api.post(url, payload).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}

export async function registerCardApi(payload) {
  const url = `${API_URL}/payment/register-card/`;
  const data = typeof payload === 'string'
    ? { payment_method_id: payload }
    : payload;
  const response = await Api.post(url, data).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}

export async function getCardInfoApi() {
  const url = `${API_URL}/payment/card-info/`;
  const response = await Api.get(url).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}

export async function deleteCardApi() {
  const url = `${API_URL}/payment/card/`;
  const response = await Api.delete(url).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}

export async function finalize3dsReturnApi(paymentIntentId, paymentIntentClientSecret) {
  const params = new URLSearchParams({
    payment_intent: paymentIntentId,
  });
  if (paymentIntentClientSecret) {
    params.set('payment_intent_client_secret', paymentIntentClientSecret);
  }
  const url = `${API_URL}/payment/3ds-complete/?${params.toString()}`;
  const response = await Api.get(url).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}

export async function getReceiptListApi(params) {
  const url = `${API_URL}/payments/receipts/`;
  const response = await Api.get(url, { params }).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}

export async function downloadReceiptApi(receiptId) {
  const url = `${API_URL}/payments/receipts/${receiptId}/download/`;
  const response = await Api.get(url).catch(handleError);
  if (!response) {
    return { status: 0, data: null };
  }
  return { status: response.status, data: response.data };
}
